module.exports = __webpack_public_path__ + "img/a1.8281b340.png";